export default {"src":"/_next/static/media/fire_64.2e4e67fc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};